"use client";

import React from "react";

function cn(...classes: Array<string | false | undefined | null>) {
  return classes.filter(Boolean).join(" ");
}

interface StrengthBarProps {
  value: number; // 0..4
}

export function StrengthBar({ value }: StrengthBarProps) {
  const bars = [0, 1, 2, 3];
  return (
    <div className="mt-2">
      <div className="flex items-center gap-2">
        <div className="flex gap-1">
          {bars.map((i) => (
            <div
              key={i}
              className={cn(
                "h-1.5 w-10 rounded-full",
                value === 0
                  ? "bg-white/10"
                  : i < value
                  ? "bg-emerald-400/90"
                  : "bg-white/10"
              )}
            />
          ))}
        </div>
        <span className="text-xs text-white/60">
          {value === 0
            ? ""
            : value === 1
            ? "Weak"
            : value === 2
            ? "Okay"
            : value === 3
            ? "Strong"
            : "Very strong"}
        </span>
      </div>
    </div>
  );
}

export function passwordScore(pw: string): number {
  if (!pw) return 0;
  let score = 0;
  if (pw.length >= 8) score++;
  if (/[A-Z]/.test(pw)) score++;
  if (/[0-9]/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  return Math.min(4, score);
}

